import Vue from "vue";
import moment from "moment";

Vue.filter("formatDate", function(value, format) {
  if (value) {
    return moment(String(value)).format(format);
  }
});

Vue.filter("statusToColor", function(value) {
  if ([7].indexOf(value) > -1) {
    return "o-status o-status--green";
  } else if ([1].indexOf(value) > -1) {
    return "o-status o-status--blue";
  } else if ([3, 4, 5, 6, 10, 11].indexOf(value) > -1) {
    return "o-status o-status--yellow";
  } else if ([2, 8].indexOf(value) > -1) {
    return "o-status o-status--pink";
  } else if ([9].indexOf(value) > -1) {
    return "o-status o-status--grey";
  }
});

Vue.filter("eventToColor", function(item) {
  if (["Confirm"].indexOf(item.eventType) > -1 && !item.profile) {
    return "o-status o-status--green";
  } else if (["Use", "Deactivate"].indexOf(item.eventType) > -1) {
    return "o-status o-status--pink";
  } else if (["ReferTo"].indexOf(item.eventType) > -1) {
    return "o-status o-status--yellow";
  }
});

Vue.filter("timeToDate", function(value, format) {
  var datetime = moment(value, format)._d;
  return datetime;
});
